const directionRevealOptions = {
	selector: ".direction-reveal--demo-roll-out",
	itemSelector: ".direction-reveal__card",
	animationName: "roll-out",
	animationPostfixEnter: "enter",
	animationPostfixLeave: "leave",
	enableTouch: true,
	touchThreshold: 250
};

export default directionRevealOptions;